import { Injectable } from '@angular/core';

import { ISlip } from '../../../../../bet-generation/models';
import { CriteriaType, IRewardToken } from '../../../../../reward-tokens/reward-tokens.model';
import { parseMarketType } from '../../../../../reward-tokens/services/reward-tokens.utils';
import { BetslipError } from '../../../../errors/betslip-error';
import { RewardTokensBetBuilderError } from '../../../../errors/general/betandget/reward-tokens-bet-builder-error';
import { RewardTokensForbiddenError } from '../../../../errors/general/reward-tokens-forbidden-error';
import { RewardTokensGameTypeError } from '../../../../errors/general/reward-tokens-game-type-error';
import { RewardTokensMinLegsError } from '../../../../errors/general/reward-tokens-min-legs-error';
import { RewardTokensSlipTypeError } from '../../../../errors/general/reward-tokens-slip-type-error';
import { RewardTokensTradingEntityMismatchError } from '../../../../errors/general/reward-tokens-trading-entity-mismatch-error';
import { SlipValidationContext, TokenEligibility } from '../../../../models/models';
import { IContextSlipValidator } from '../validators';

function getMarketTypes(token: IRewardToken): { name: string }[] {
    const marketTypes = parseMarketType(token);

    return (
        marketTypes?.map((mt) => {
            return { name: mt };
        }) ?? []
    );
}

@Injectable()
export class RewardTokensCriteriaErrorValidator implements IContextSlipValidator<BetslipError> {
    validate(_: ISlip, { rewardTokens }: SlipValidationContext): Iterable<BetslipError> {
        const selectedToken = rewardTokens.selectedToken;
        const eligibilityState = rewardTokens.selectedTokenEligibilityState;

        if (!selectedToken || !eligibilityState) {
            return [];
        }

        return RewardTokensCriteriaErrorValidator.validate(selectedToken, eligibilityState);
    }

    static validate(token: IRewardToken, eligibilityState: TokenEligibility) {
        switch (eligibilityState?.invalidHardCriteria) {
            case CriteriaType.Forbidden:
                return [new RewardTokensForbiddenError()];
            case CriteriaType.Sports:
                return [new RewardTokensTradingEntityMismatchError(CriteriaType.Sports, token.filter.sports)];
            case CriteriaType.Competitions:
                return [new RewardTokensTradingEntityMismatchError(CriteriaType.Competitions, token.filter.competitions)];
            case CriteriaType.Meetings:
                return [new RewardTokensTradingEntityMismatchError(CriteriaType.Meetings, token.filter.meetings)];
            case CriteriaType.Fixtures:
                return [new RewardTokensTradingEntityMismatchError(CriteriaType.Fixtures, token.filter.fixtures)];
            case CriteriaType.OptionId:
                return [new RewardTokensTradingEntityMismatchError(CriteriaType.OptionId, token.filter.options)];
            case CriteriaType.MarketId:
                return [new RewardTokensTradingEntityMismatchError(CriteriaType.MarketId, token.filter.markets)];
            case CriteriaType.TemplateId:
                return [new RewardTokensTradingEntityMismatchError(CriteriaType.TemplateId, token.filter.marketTemplates)];
            case CriteriaType.MarketParameter:
                return [new RewardTokensTradingEntityMismatchError(CriteriaType.MarketParameter, getMarketTypes(token))];
            case CriteriaType.GameType:
                return [new RewardTokensGameTypeError(token.filter.gameType!)];
            case CriteriaType.BetBuilder:
                return [new RewardTokensBetBuilderError(token)];
        }

        if (eligibilityState?.softCriteriasValidity[CriteriaType.SlipType] === false) {
            return [new RewardTokensSlipTypeError(token.filter.betSlipType!)];
        }

        if (eligibilityState?.softCriteriasValidity[CriteriaType.MinimumLegs] === false) {
            return [new RewardTokensMinLegsError(token.minimumLegs!)];
        }

        return [];
    }
}
